var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white h-screen"},[_c('div',{staticClass:"max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8 flex h-full flex-col justify-center"},[_c('Nuxt')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }